var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-stacked-column-chart',{attrs:{"bars":_vm.data,"group-by":_vm.groupBy,"x-axis-type":"category","y-axis-type":"value","x-axis-title":_vm.__('Date'),"y-axis-title":_vm.s__('CycleAnalytics|Number of tasks'),"option":_vm.$options.additionalOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }